<template>
    <v-card class="transparent" flat>
        <v-card-actions>
            <v-btn class="indigo text-capitalize" dark to="/masa-sanggah">Dalam Masa Sanggah</v-btn>
            <v-btn class="indigo text-capitalize" dark to="/hasil-tender">Hasil Tender</v-btn>
        </v-card-actions>
        <v-card-text>
            <v-data-table :headers="table.headers" :items="table.items" :items-per-page="15" no-data-text="MASA SANGGAH">
                <template v-slot:item.mulai="{item}">
                    {{ getDateTimeFormatted(item.mulai) }}
                </template>
                <template v-slot:item.selesai="{item}">
                    {{ getDateTimeFormatted(item.selesai) }}
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>


<script>

const axios = require('axios').default;
const apiUrl = process.env.VUE_APP_ROOT_API
import { format } from 'date-fns';


export default {
    data() {
        return {
            table: {
                headers: [
                    { text: "Nama Paket", value: "nama", class: "light-blue lighten-2 subtitle-1 font-weight-bold" },
                    { text: "Tanggal Mulai", value: "mulai", class: "light-blue lighten-2 subtitle-1 font-weight-bold" },
                    { text: "Tanggal Selesai", value: "selesai", class: "light-blue lighten-2 subtitle-1 font-weight-bold" },
                ],
                items: []
            },
        }

    }, // data


    mounted() {
        axios.get(`${apiUrl}/api/lelang/masa-sanggah`)
        .then( (response) => {
            this.table.items = response.data;
        }).catch( (error) => {
            console.error(error);
        });

    }, // mounted


    methods: {
        getDateTimeFormatted(dateTime) {
            return dateTime ? format(Date.parse(dateTime), "dd-MM-yyyy") : ""
        },

    }, // methods

}

</script>
